require.config( {

	baseUrl: '../../js/',

	deps: [
		'bootstrap'
	],
	paths: {
		components: '../src/sublayouts',
		text: 'vendor/require.text',
		jquery: 'vendor/jquery',
		jquery_mobile_touch: 'vendor/jquery.mobile.touch',
		slick: 'vendor/slick',
		iscroll: 'vendor/iscroll',
		mustache: 'vendor/mustache',
		picker: 'vendor/picker',
		pickerdate: 'vendor/picker.date',
		parsley: 'vendor/parsley',
		highcharts: 'vendor/highcharts',
		chat: 'vendor/chat',
		numeral: 'vendor/numeral'
	},

	shim: {
		'picker': {
			deps: [ 'jquery' ]
		},
		'pickerdate': {
			deps: [ 'jquery', 'picker' ]
		},
		'parsley': {
			deps: [ 'jquery' ]
		},
		'highcharts': {
			exports: 'Highcharts',
			deps: [ 'jquery' ]
		}
	},

	map: {
		'*': {
			'jquery': 'jquery-private'
		},
		'jquery-private': {
			'jquery': 'jquery'
		}
	}
} );

define("config/requirejs", function(){});

